export const CLASS_NAMES = {
  headerWrapper: 'md:text-center',
  title: 'text-style-b mb-4 text-neutral-900',
  description:
    'text-style-g mb-8 text-neutral-700 whitespace-pre-line md:text-style-f md:text-neutral-600',
  error: 'text-style-h text-red-200 mb-4 -mt-4',
  text: 'my-auto text-14-22',
  linktext: 'text-14-22-em text-purple-300 ml-1',
};

export const TITLE = 'Your session has expired!';

export const DESCRIPTION =
  'Welcome back to Kanda! To continue and\nsee the status of your job, please follow\nthe link in your email';
